/** Animation frame functions; hosts pass their window's so tests can drive frames. */
export interface HsAnimationFrames {
  requestAnimationFrame(callback: (time: number) => void): number;
  cancelAnimationFrame(handle: number): void;
}

/**
 * Draws on demand: `request()` schedules one animation frame however often it is called before the
 * frame runs, so input handlers and loaders can ask for redraws freely. A frame that wants another one
 * (distributed rendering, a running animation) calls `request()` again.
 */
export class HsRenderLoop {
  private handle: number = 0;

  public constructor(private readonly onFrame: () => void, private readonly frames: HsAnimationFrames) {}

  public get scheduled(): boolean {
    return this.handle !== 0;
  }

  public request(): void {
    if (this.handle !== 0) {
      return;
    }
    this.handle = this.frames.requestAnimationFrame(() => {
      this.handle = 0;
      this.onFrame();
    });
  }

  public cancel(): void {
    if (this.handle !== 0) {
      this.frames.cancelAnimationFrame(this.handle);
      this.handle = 0;
    }
  }
}
